module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Sign-out-41122c91e40e8b9bc800315fab485b39.svg";